import { motion } from 'framer-motion';

interface StatusBarItem {
  label: string;
  count: number;
  color: string;
}

interface Props {
  data: StatusBarItem[];
  labelClassName?: string;
  footerLabel?: string;
  footerValue?: number;
}

export function StatusBars({ data, labelClassName = 'max-w-28', footerLabel, footerValue }: Props) {
  const total = data.reduce((sum, item) => sum + item.count, 0);
  if (!data.length) return null;

  return (
    <>
      <div className='space-y-4'>
        {data.map((item) => {
          const pct = total > 0 ? Math.round((item.count / total) * 100) : 0;

          return (
            <div key={item.label}>
              <div className='flex items-center justify-between mb-1.5'>
                <div className='flex items-center gap-2'>
                  <span
                    className='w-2 h-2 rounded-full shrink-0'
                    style={{ background: item.color }}
                  />
                  <span className={`text-sm text-foreground truncate ${labelClassName}`}>
                    {item.label}
                  </span>
                </div>
                <div className='flex items-center gap-2'>
                  <span className='text-sm font-bold text-foreground'>{item.count}</span>
                  <span className='text-xs text-muted-foreground w-8 text-right'>{pct}%</span>
                </div>
              </div>
              <div className='h-2 rounded-full bg-muted overflow-hidden'>
                <motion.div
                  className='h-full rounded-full'
                  style={{ background: item.color }}
                  initial={{ width: 0 }}
                  animate={{ width: `${pct}%` }}
                  transition={{ duration: 0.7, delay: 0.2, ease: 'easeOut' }}
                />
              </div>
            </div>
          );
        })}
      </div>

      {footerLabel && footerValue !== undefined && (
        <div className='mt-5 pt-4 border-t border-border/20 flex items-center justify-between'>
          <span className='text-xs text-muted-foreground'>{footerLabel}</span>
          <span className='text-sm font-bold text-foreground'>{footerValue}</span>
        </div>
      )}
    </>
  );
}
